import React, {useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import Select from 'components/Select';
import GuaranteeItems from 'constants/GuaranteeItems';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import WadiumTable from './components/WadiumTable';
import {connect} from 'react-redux'
import SaveFormikValues from 'components/SaveFormikValues';
import GuaranteeService from 'services/GuaranteeService';
import {withRouter} from "react-router";
import getObjectValue from 'libs/getObjectValue';
import Loading from 'components/Loading';
import validation from './constants/validation';
import {DemandValidation} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import {setFormDraftLoaded} from "redux/actions";
import Confirm from "components/popup/confirm/Confirm";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import saveFormDraft from "libs/saveFormDraft";

const style = theme => ({
    root: {
        width: '100%'
    },
    container: {
        "&>*": {
            width: '100%'
        }
    }
})

function Wadium(
    {
        classes,
        stepperState,
        match,
        demandValidation,
        guaranteeList,
        setFormDraftLoaded,
        demandHeader
    }) {
    const GUARANTEE_SELECT_YES = 'yes';
    const FORM_ID = 'mp_1_guarantee'
    const section = demandValidation.find(x => x.section === DemandValidation.GUARANTEE);
    const id = match.params.id;
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => GuaranteeService.deleteDraft(id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(id, GuaranteeService.saveDraft, FORM_ID) : undefined);

    useEffect(() => {
        GuaranteeService.get(id).then(() => {
            if (autoSaveFormDraftActive)
                GuaranteeService.checkForDraft(id).then(res => setDraftConfirm(res.result))
        });

        return () => GuaranteeService.clearGuaranteeList();
    }, [id, autoSaveFormDraftActive])

    const handleSubmit = (values, formikProps) => {
        GuaranteeService.save(id, values)
            .then((result) => {
                if (!result.success) {
                    const errors = result.errors;
                    Object.keys(errors).forEach((errorId) => {
                        formikProps.setFieldError(errorId.replaceAll("[", ".").replaceAll("]", ""), errors[errorId])
                    })
                }
            });
    }

    const loadGuaranteeDraft = () => {
        setDraftConfirm(false);
        setWorking(true);
        GuaranteeService.loadDraft(id).then(res => setFormDraftLoaded(FORM_ID, res.success));
        setWorking(false);
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, guaranteeList, defaultValue);

    if (!guaranteeList || working) {
        return <Loading/>
    }
    return (
        <>
            <Form
                className={classes.root}
                initialValues={{
                    _editable: section ? section.editable : true,
                    identity: getField('identity'),
                    status: getField('status', 'not_specified'),
                    warningThreshold: getField('warningThreshold'),
                    dealings: getField('dealings'),
                }}
                validationSchema={validation}
                id={FORM_ID}
                onSubmit={handleSubmit}
                afterSubmitFunc={() => {
                    if (isDemandModification()) {
                        ModificationService.isDemandChanged(id);
                    }
                }}
            >
                {(formikProps) => (
                    <>
                        <SaveFormikValues
                            formikProps={formikProps}
                            id={FORM_ID}
                            save={FORM_ID === stepperState}
                        />
                        {autoSaveFormDraftActive &&
                        <AutoSaveFormValues
                            formikProps={formikProps}
                            id={id}
                            formId={FORM_ID}
                            saveFunc={(formValues) => {
                                GuaranteeService.saveDraft(id, formValues)
                            }}
                        />
                        }
                        <GridBlock direction='column' className={classes.container}>
                            <Select
                                label={Tr('wadium_question')}
                                id='status'
                                formikProps={formikProps}
                                items={GuaranteeItems}
                            />
                            {formikProps.values.status === GUARANTEE_SELECT_YES &&
                            <WadiumTable formikProps={formikProps}/>
                            }
                        </GridBlock>
                    </>
                )}
            </Form>
            <Confirm
                open={draftConfirm}
                onConfirm={loadGuaranteeDraft}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </>
    )
}

Wadium.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stepperState: state.stepper.state,
    guaranteeList: state.resources.guaranteeList,
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {setFormDraftLoaded})(withRouter(withStyles(style)(Wadium)));